<template>
  <div class="home">
    <ul>
      <li>
        <router-link to="/dopa">DOPAmine</router-link>
      </li>
      <li>
        <router-link to="/dobu">doBUTAmine</router-link>
      </li>
      <li>
        <router-link to="/nica">NiCARdipine</router-link>
      </li>
      <li>
        <router-link to="/nore">Norepinephrine</router-link>
      </li>
      <li>
        <router-link to="/crcl">CrCl calc.</router-link>
      </li>
    </ul>
     <h3 class="title">Reference</h3>
     <ol>
       <li><a href="https://www2.si.mahidol.ac.th/km/knowledgebase/medicine/highalertdrug/7684/">คู่มือการใช้ยาที่มีความเสี่ยงสูง High Alert Drug โดย คณะกรรมการเภสัชกรรม และการบำบัด โรงพยาบาลศิริราช (ฉบับปรับปรุง เมษายน 2560) </a></li>
       <li><a href="https://online.lexi.com/">Lexi-Drugs Online. [cited 2020 Sep 13]</a></li>
     </ol>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      d1: 5
    };
  }
};
</script>

<style scope >
</style>